const GIFT_CARDS_VIEW_MODE_DE = {
  PURCHASE: 'bestellen',
  BALANCE: 'saldo',
};

const GIFT_CARDS_VIEW_MODE_FR = {
  PURCHASE: 'commander',
  BALANCE: 'solde',
};

export const HOME = '/';

// Register
export const PRE_REGISTER = '/pre-register';
export const REGISTER = '/register';
export const REGISTER_SUCCESS = '/register-success';
export const EMAIL_SENT = '/email-sent';
export const ACTIVATION_RESEND = '/auth/activation-resend';
export const ACTIVATE_ACCOUNT = '/auth/activation';
export const CREATE_PROFILE = '/create-profile';

// Login
export const PRE_LOGIN = '/pre-login';
export const LOGIN = '/login';
export const VIP_CARD_LOGIN = '/vip-card-login';
export const PATIENCE = '/auth/card/patience';

// Forgot password
export const FORGOT_PASSWORD = '/auth/password/forgot-password';
export const PASSWORD_RESET_SENT = '/auth/password/reset-sent';
export const PASSWORD_RESET_CHANGE = '/auth/password/change';

// CMS
export const CMS_PAGE = '/[...slug]';

// Products
export const PRODUCT = '/products/[slug]/id/[id]';
export const PRODUCT_AVAILABILITY = '/products/[slug]/id/[id]/#availability';
export const PRODUCTS_CATEGORY = '/products/categories/[slug]/[id]';
export const PRODUCTS_SALE = '/products/sale';
export const PRODUCTS_NEW = '/products/new';
export const PRODUCTS_OFFER = '/products/offer';
export const PRODUCTS_ALL = '/products';
export const PRODUCTS_CATCH_ALL = '/products/[...slug]';

// Stores
export const STORE_FINDER = '/stores/finder/[type]';
export const STORE = '/stores/[slug]/[store]';

// Jobs
export const JOBS_JOB_OFFER_DETAILS = '/jobs/job-offer/[slug]/[id]';
export const JOBS_OPERATION_AREA_DETAILS = '/jobs/[slug]/[id]';
export const JOBS_SPONTANEOUS_APPLICATION = '/jobs/spontaneous-application';
export const JOBS_APPLICATION_SENT = '/jobs/application-sent';

// Newsletter
export const NEWSLETTER_REGISTRATION = '/newsletter/registration';
export const NEWSLETTER_REGISTRATION_CONFIRM =
  '/newsletter/registration/confirm';
export const NEWSLETTER_UNREGISTER = '/newsletter/unregister';
export const NEWSLETTER_UNREGISTER_NON_VIP = '/newsletter/non-vip/unregister';

// Vip
export const VIP_HOME = '/vip';
export const ACCOUNT_OPTIMIZATION = '/vip/account-optimization';
export const VIP_ACTIVITIES = '/vip/activities/[type]';
export const VIP_ACTIVITIES_ALL = '/vip/activities/all';
export const VIP_ACTIVITIES_PURCHASES = '/vip/activities/purchases';
export const VIP_GOODIES = '/vip/goodies';
export const VIP_SETTINGS = '/vip/settings';
export const VIP_SETTINGS_ACCOUNT_DELETION = '/vip/settings/deletion';
export const VIP_SETTINGS_AVATAR = '/vip/settings/avatar';
export const VIP_SETTINGS_CHANGE_EMAIL = '/vip/settings/change-email';
export const VIP_SETTINGS_CHANGE_EMAIL_CONFIRM =
  '/vip/settings/change-email/confirm';
export const VIP_SETTINGS_CHANGE_EMAIL_TOKEN =
  '/vip/settings/change-email-confirm';
export const VIP_SETTINGS_CHANGE_PASSWORD = '/vip/settings/change-password';
export const VIP_SETTINGS_NOTIFICATIONS = '/vip/settings/notifications';
export const VIP_SETTINGS_PROFILE_DETAILS = '/vip/settings/profile';
export const VIP_SINGLE_PURCHASE = '/vip/purchase/[id]';
export const VIP_VOUCHERS = '/vip/vouchers';
export const VIP_INVALID_CARD = '/vip-invalid-card';
export const VIP_CARD_NOT_YET_ACTIVATED = '/vip-card-inactive';
export const VIP_CARD_ALREADY_ACTIVATED = '/vip-card-active';
export const VIP_CARD_INVALID_EMAIL = '/vip-card-invalid-email';

// Games
export const GAME_WOF = '/games/wof-splash';
export const GAME_TROPHY_HUNT = '/games/trophy-hunt-splash';
export const GAME_ADVENTCALENDAR = '/games/adventcalendar-splash';
export const GAME_BAG = '/games/bag-challenge-splash';
export const GAME_EASTER_JACKPOT = '/games/easter-jackpot-splash';
export const GAME_WOF_PLAY = '/games/wof-web';
export const GAME_WOF_PLAYED = '/games/wof-played';
export const GAME_WOF_UNAVAILABLE = '/games/wof-unavailable';

// Moment / Shop event
export const SHOP_EVENT = '/shop-event';
export const SHOP_EVENT_PRODUCT = '/shop-event/products/[slug]/[id]';

// Checkout
export const CHECKOUT = '/checkout';
export const CHECKOUT_SUCCESS = '/checkout/success';
export const CHECKOUT_GATEWAY = '/checkout/gateway/[paymentStatus]';

// Gift Cards
export const GIFT_CARDS_VIEW = '/gift-cards/[view]';
export const GIFT_CARDS_BALANCE_CHECK = '/gift-cards/balance/check';
export const GIFT_CARDS_PURCHASE_SUMMARY = '/gift-cards/purchase/summary';
export const GIFT_CARDS_PURCHASE_SUCCESS = '/gift-cards/purchase/success';
export const GIFT_CARDS_PURCHASE_GATEWAY =
  '/gift-cards/purchase/gateway/[paymentStatus]';

// Misc
export const BASKET = '/basket';
export const NOT_FOUND = '/404';
export const AUTH_TERMS_AND_CONDITIONS = '/auth/terms-and-conditions';
export const VERIFY_ADDRESS = '/verify-address/[token]';
export const FAVORITES = '/favorites';
export const GOODIES_DETAILS = '/goodies/[slug]/[id]';
export const CMS_LOOKBOOK_PAGE = '/lookbooks/[...slug]';
export const DELIVERY_CONDITIONS = '/delivery-conditions';

// URLs
export const JOBS_HOME_URL = {
  de: () => '/arbeiten-bei-chicoree/',
  fr: () => '/travailler-pour-chicoree/',
};

export const SCREEN_NAME_UNKNOWN = 'unknown';

export const FIXED_ROUTES = [
  STORE_FINDER,
  AUTH_TERMS_AND_CONDITIONS,
  FAVORITES,
  JOBS_SPONTANEOUS_APPLICATION,
  PRODUCTS_OFFER,
  PRODUCTS_SALE,
  PRODUCTS_NEW,
  PRODUCTS_ALL,
  PRODUCTS_CATCH_ALL,
  GAME_WOF,
  GAME_TROPHY_HUNT,
  GAME_ADVENTCALENDAR,
  GAME_BAG,
  GAME_EASTER_JACKPOT,
  SHOP_EVENT,
  GIFT_CARDS_VIEW,
];

export const MASTER_SLUG_VIEW_NAME_MAP = {
  [HOME]: 'Homepage',
};

export const ROUTES_FOR_LOGGED_IN = [
  ACCOUNT_OPTIMIZATION,
  CREATE_PROFILE,
  AUTH_TERMS_AND_CONDITIONS,
  VIP_ACTIVITIES, // TODO
  VIP_GOODIES,
  VIP_HOME,
  VIP_SETTINGS,
  VIP_SETTINGS_ACCOUNT_DELETION,
  VIP_SETTINGS_AVATAR,
  VIP_SETTINGS_CHANGE_PASSWORD,
  VIP_SETTINGS_NOTIFICATIONS,
  VIP_SETTINGS_PROFILE_DETAILS,
  VIP_SETTINGS_CHANGE_EMAIL,
  VIP_SETTINGS_CHANGE_EMAIL_TOKEN,
  VIP_SETTINGS_CHANGE_EMAIL_CONFIRM,
  VIP_SINGLE_PURCHASE,
  VIP_VOUCHERS,
];

export const NOT_CACHEABLE_ROUTES = [
  ...ROUTES_FOR_LOGGED_IN,
  NEWSLETTER_UNREGISTER,
  FAVORITES,
  GOODIES_DETAILS,
  PRODUCTS_ALL,
  PRODUCTS_CATCH_ALL,
  PRODUCTS_SALE,
  PRODUCTS_NEW,
  PRODUCTS_OFFER,
  PRODUCTS_CATEGORY,
  BASKET,
];

export const germanUrlsRouteMap = {
  [ACCOUNT_OPTIMIZATION]: () => '/vip/account-optimization/',
  [ACTIVATE_ACCOUNT]: () => '/auth/activation/',
  [ACTIVATION_RESEND]: () => '/auth/activation/resend/',
  [PRODUCTS_ALL]: () => '/frauen-kleidung/',
  [PRODUCTS_CATCH_ALL]: query => `/frauen-kleidung/${query.slug}`,
  [AUTH_TERMS_AND_CONDITIONS]: () => '/auth/agb/',
  [CMS_LOOKBOOK_PAGE]: query => `/lookbooks/${query.slug}/`,
  [CMS_PAGE]: query => `/${query.slug}/`,
  [CREATE_PROFILE]: () => '/auth/customer/create/',
  [EMAIL_SENT]: () => '/auth/activation/email-sent-confirm/',
  [FAVORITES]: () => '/vip/favorites/',
  [FORGOT_PASSWORD]: () => '/auth/password/request-reset/',
  [GOODIES_DETAILS]: query => `/goodies/${query.slug}/id/${query.id}/`,
  [HOME]: () => '/',
  [JOBS_APPLICATION_SENT]: () => '/arbeiten-bei-chicoree/application-sent/',
  [JOBS_JOB_OFFER_DETAILS]: query =>
    `/offene-stellen/${query.slug}/id/${query.id}/`,
  [JOBS_OPERATION_AREA_DETAILS]: query =>
    `/arbeiten-bei-chicoree/${query.slug}/id/${query.id}/`,
  [JOBS_SPONTANEOUS_APPLICATION]: () =>
    '/arbeiten-bei-chicoree/spontanbewerbung/',
  [LOGIN]: () => '/auth/login/email/',
  [NEWSLETTER_REGISTRATION]: () => '/newsletter/registration/',
  [NEWSLETTER_REGISTRATION_CONFIRM]: () => '/newsletter/registration/confirm/',
  [NEWSLETTER_UNREGISTER]: () => '/newsletter/unregister/',
  [NOT_FOUND]: () => '/not-found/',
  [PASSWORD_RESET_CHANGE]: () => '/auth/password/reset/',
  [PASSWORD_RESET_SENT]: () => '/auth/password/request-reset/confirm/',
  [PATIENCE]: () => '/auth/login/card/patience/',
  [PRE_LOGIN]: () => '/auth/login/overview/',
  [PRE_REGISTER]: () => '/auth/registration/overview/',
  [PRODUCT]: query => `/frauen-kleidung/${query.slug}/id/${query.id}/`,
  [PRODUCT_AVAILABILITY]: query =>
    `/frauen-kleidung/${query.slug}/id/${query.id}/#availability`,
  [PRODUCTS_CATEGORY]: query =>
    `/frauen-kleidung/kategorie/${query.slug}/id/${query.id}/`,
  [PRODUCTS_NEW]: () => '/frauen-kleidung/neuheiten/',
  [PRODUCTS_OFFER]: () => '/frauen-kleidung/angebote/',
  [PRODUCTS_SALE]: () => '/frauen-kleidung/sale/',
  [REGISTER]: () => '/auth/registration/',
  // TODO translate url
  [REGISTER_SUCCESS]: () => '/auth/registration/success/',
  [STORE]: query => `/filialen/${query.slug}/id/${query.store}/`,
  [STORE_FINDER]: query => `/filialen/${query.type || 'alle'}/`,
  [VERIFY_ADDRESS]: query => `/verify-address/${query.token}/`,
  [VIP_ACTIVITIES]: query => `/vip/activities/${query.type}/`,
  [VIP_ACTIVITIES_ALL]: () => '/vip/activities/all/',
  [VIP_ACTIVITIES_PURCHASES]: () => '/vip/activities/purchase/',
  [VIP_CARD_LOGIN]: () => '/auth/login/card/',
  [VIP_GOODIES]: () => '/vip/goodies/',
  [VIP_HOME]: () => '/vip/',
  [VIP_SETTINGS]: () => '/vip/settings/',
  [VIP_SETTINGS_ACCOUNT_DELETION]: () => '/vip/settings/account-deletion/',
  [VIP_SETTINGS_AVATAR]: () => '/vip/settings/avatar/',
  [VIP_SETTINGS_CHANGE_EMAIL]: () => '/vip/settings/change-email/',
  [VIP_SETTINGS_CHANGE_EMAIL_CONFIRM]: () =>
    '/vip/settings/change-email/confirm/',
  [VIP_SETTINGS_CHANGE_EMAIL_TOKEN]: () =>
    '/vip/settings/change-email-confirm/',
  [VIP_SETTINGS_CHANGE_PASSWORD]: () => '/vip/settings/change-password/',
  [VIP_SETTINGS_NOTIFICATIONS]: () => '/vip/settings/notifications/',
  [VIP_SETTINGS_PROFILE_DETAILS]: () => '/vip/settings/profile/',
  [VIP_SINGLE_PURCHASE]: query => `/vip/purchase/${query.id}/`,
  [VIP_VOUCHERS]: () => '/vip/vouchers/',
  [VIP_INVALID_CARD]: () => '/auth/login/card/unavailable-for-signup/',
  [VIP_CARD_NOT_YET_ACTIVATED]: () => '/auth/login/card/not-activated/',
  [VIP_CARD_INVALID_EMAIL]: () => '/auth/login/card/invalid-email/',
  [VIP_CARD_ALREADY_ACTIVATED]: () => '/auth/login/card/already-activated/',
  // TODO translate urls
  [GAME_WOF]: () => '/wof-splash/',
  [GAME_WOF_PLAY]: query => `/wof-web?token=${query.token}`,
  [GAME_WOF_PLAYED]: () => '/wof-played/',
  [GAME_WOF_UNAVAILABLE]: () => '/wof-unavailable/',
  [GAME_BAG]: () => '/bag-challenge-splash/',
  [GAME_EASTER_JACKPOT]: () => '/easter-jackpot-splash/',
  [GAME_TROPHY_HUNT]: () => '/trophy-hunt-splash/',
  [GAME_ADVENTCALENDAR]: () => '/adventcalendar-splash/',
  [SHOP_EVENT]: () => '/moments-online-shopping-day/',
  [SHOP_EVENT_PRODUCT]: query =>
    `/moments-online-shopping-day/products/${query.slug}/${query.id}/`,
  [BASKET]: () => '/basket/',
  [CHECKOUT]: () => '/checkout/',
  [CHECKOUT_SUCCESS]: () => '/checkout/success/',
  [CHECKOUT_GATEWAY]: query => `/checkout/gateway/${query.paymentStatus}/`,
  [DELIVERY_CONDITIONS]: () =>
    '/moments-online-shopping-day-lieferbedingungen/',
  [GIFT_CARDS_BALANCE_CHECK]: () =>
    `/geschenkkarten/${GIFT_CARDS_VIEW_MODE_DE.BALANCE}/result/`,
  [GIFT_CARDS_PURCHASE_SUMMARY]: () => '/geschenkkarten/checkout/',
  [GIFT_CARDS_PURCHASE_SUCCESS]: () => '/geschenkkarten/checkout/success/',
  [GIFT_CARDS_PURCHASE_GATEWAY]: query =>
    `/geschenkkarten/checkout/${query.paymentStatus}`,
  [GIFT_CARDS_VIEW]: query =>
    `/geschenkkarten/${query.view || GIFT_CARDS_VIEW_MODE_DE.PURCHASE}/`,
};

export const germanUrlsLinkGenerationRouteMap = {
  [HOME]: '/',
  [ACTIVATE_ACCOUNT]: '/auth/activation/',
  [ACTIVATION_RESEND]: '/auth/activation/resend/',
  [EMAIL_SENT]: '/auth/activation/email-sent-confirm/',
  [AUTH_TERMS_AND_CONDITIONS]: '/auth/agb/',
  [CREATE_PROFILE]: '/auth/customer/create/',
  [FORGOT_PASSWORD]: '/auth/password/request-reset/',
  [PASSWORD_RESET_CHANGE]: '/auth/password/reset/',
  [PASSWORD_RESET_SENT]: '/auth/password/request-reset/confirm/',
  [LOGIN]: '/auth/login/email/',
  [PATIENCE]: '/auth/login/card/patience/',
  [PRE_LOGIN]: '/auth/login/overview/',
  [PRE_REGISTER]: '/auth/registration/overview/',
  [REGISTER]: '/auth/registration/',
  [REGISTER_SUCCESS]: '/auth/registration/success/',
  [VIP_CARD_LOGIN]: '/auth/login/card/',
  [VERIFY_ADDRESS]: '/verify-address/:token/',

  [ACCOUNT_OPTIMIZATION]: '/vip/account-optimization/',
  [FAVORITES]: '/vip/favorites/',
  [GOODIES_DETAILS]: '/goodies/:slug/id/:id/',
  [JOBS_APPLICATION_SENT]: '/arbeiten-bei-chicoree/application-sent/',
  [JOBS_JOB_OFFER_DETAILS]: '/offene-stellen/:slug/id/:id/',
  [JOBS_OPERATION_AREA_DETAILS]: '/arbeiten-bei-chicoree/:slug/id/:id/',
  [JOBS_SPONTANEOUS_APPLICATION]: '/arbeiten-bei-chicoree/spontanbewerbung/',
  [NEWSLETTER_REGISTRATION]: '/newsletter/registration/',
  [NEWSLETTER_REGISTRATION_CONFIRM]: '/newsletter/registration/confirm/',
  [NEWSLETTER_UNREGISTER]: '/newsletter/unregister/',
  [NOT_FOUND]: '/not-found/',

  [PRODUCT]: '/frauen-kleidung/:slug/id/:id/',
  [PRODUCT_AVAILABILITY]: '/frauen-kleidung/:slug/id/:id/#availability/',
  [PRODUCTS_CATEGORY]: '/frauen-kleidung/kategorie/:slug/id/:id/',
  [PRODUCTS_NEW]: '/frauen-kleidung/neuheiten/',
  [PRODUCTS_OFFER]: '/frauen-kleidung/angebote/',
  [PRODUCTS_SALE]: '/frauen-kleidung/sale/',
  [PRODUCTS_ALL]: '/frauen-kleidung/',
  [PRODUCTS_CATCH_ALL]: '/frauen-kleidung/:slug+/',

  [SHOP_EVENT]: '/moments-online-shopping-day/',
  [SHOP_EVENT_PRODUCT]: '/moments-online-shopping-day/products/:slug/:id/',
  [BASKET]: '/basket/',
  [CHECKOUT]: '/checkout/',
  [CHECKOUT_SUCCESS]: '/checkout/success/',
  [CHECKOUT_GATEWAY]: '/checkout/gateway/:paymentStatus/',
  [DELIVERY_CONDITIONS]: '/moments-online-shopping-day-lieferbedingungen/',

  [STORE]: '/filialen/:slug/id/:store/',
  [STORE_FINDER]: '/filialen/:type/',

  [VIP_ACTIVITIES]: '/vip/activities/:type/',
  [VIP_ACTIVITIES_ALL]: '/vip/activities/all/',
  [VIP_ACTIVITIES_PURCHASES]: '/vip/activities/purchase/',
  // [VIP_GOODIES]: '/vip/goodies/',
  [VIP_HOME]: '/vip/',
  [VIP_SETTINGS]: '/vip/settings/',
  [VIP_SETTINGS_ACCOUNT_DELETION]: '/vip/settings/account-deletion/',
  [VIP_SETTINGS_AVATAR]: '/vip/settings/avatar/',
  [VIP_SETTINGS_CHANGE_EMAIL]: '/vip/settings/change-email/',
  [VIP_SETTINGS_CHANGE_EMAIL_CONFIRM]: '/vip/settings/change-email/confirm/',
  [VIP_SETTINGS_CHANGE_EMAIL_TOKEN]: '/vip/settings/change-email-confirm/',
  [VIP_SETTINGS_CHANGE_PASSWORD]: '/vip/settings/change-password/',
  [VIP_SETTINGS_NOTIFICATIONS]: '/vip/settings/notifications/',
  [VIP_SETTINGS_PROFILE_DETAILS]: '/vip/settings/profile/',
  [VIP_SINGLE_PURCHASE]: '/vip/purchase/:id/',
  // [VIP_VOUCHERS]: '/vip/vouchers/',
  [VIP_INVALID_CARD]: '/auth/login/card/unavailable-for-signup/',
  [VIP_CARD_NOT_YET_ACTIVATED]: '/auth/login/card/not-activated/',
  [VIP_CARD_INVALID_EMAIL]: '/auth/login/card/invalid-email/',
  [VIP_CARD_ALREADY_ACTIVATED]: '/auth/login/card/already-activated/',

  [GAME_WOF]: '/wof-splash/',
  [GAME_WOF_PLAY]: '/wof-web/',
  [GAME_WOF_PLAYED]: '/wof-played/',
  [GAME_WOF_UNAVAILABLE]: '/wof-unavailable/',
  [GAME_BAG]: '/bag-challenge-splash/',
  [GAME_EASTER_JACKPOT]: '/easter-jackpot-splash/',
  [GAME_TROPHY_HUNT]: '/trophy-hunt-splash/',
  [GAME_ADVENTCALENDAR]: '/adventcalendar-splash/',

  [GIFT_CARDS_BALANCE_CHECK]: `/geschenkkarten/${GIFT_CARDS_VIEW_MODE_DE.BALANCE}/result/`,
  [GIFT_CARDS_PURCHASE_SUMMARY]: '/geschenkkarten/checkout/',
  [GIFT_CARDS_PURCHASE_SUCCESS]: '/geschenkkarten/checkout/success/',
  [GIFT_CARDS_PURCHASE_GATEWAY]:
    '/geschenkkarten/checkout/gateway/:paymentStatus/',
  [GIFT_CARDS_VIEW]: '/geschenkkarten/:view/',

  // NOTE: overwrite the goodies and vouchers routes as they are temporarily not available
  '/vip/goodies-vouchers-splash': {
    source: '/vip/:goodiesVouchers(goodies|vouchers)/',
    pattern: '/vip/(goodies|vouchers)-splash/',
  },

  [CMS_LOOKBOOK_PAGE]: '/lookbooks/:slug/',
  [CMS_PAGE]: {
    source: '/:slug((?!_next))+/',
    pattern: '/*',
  },
};

export const frenchUrlsRouteMap = {
  [ACCOUNT_OPTIMIZATION]: () => '/vip/account-optimization/',
  [ACTIVATE_ACCOUNT]: () => '/auth/activation/',
  [ACTIVATION_RESEND]: () => '/auth/activation/resend/',
  [PRODUCTS_ALL]: () => '/vetements-femmes/',
  [PRODUCTS_CATCH_ALL]: query => `/vetements-femmes/${query.slug}`,
  [AUTH_TERMS_AND_CONDITIONS]: () => '/auth/cgv/',
  [CMS_LOOKBOOK_PAGE]: query => `/lookbooks/${query.slug}/`,
  [CMS_PAGE]: query => `/${query.slug}/`,
  [CREATE_PROFILE]: () => '/auth/customer/create/',
  [EMAIL_SENT]: () => '/auth/activation/email-sent-confirm/',
  [FAVORITES]: () => '/vip/favorites/',
  [FORGOT_PASSWORD]: () => '/auth/password/request-reset/',
  [GOODIES_DETAILS]: query => `/goodies/${query.slug}/id/${query.id}/`,
  [HOME]: () => '/',
  [JOBS_APPLICATION_SENT]: () => '/travailler-pour-chicoree/application-sent/',
  [JOBS_JOB_OFFER_DETAILS]: query =>
    `/postes-vacants/${query.slug}/id/${query.id}/`,
  [JOBS_OPERATION_AREA_DETAILS]: query =>
    `/travailler-pour-chicoree/${query.slug}/id/${query.id}/`,
  [JOBS_SPONTANEOUS_APPLICATION]: () =>
    '/travailler-pour-chicoree/candidature-spontanee/',
  [LOGIN]: () => '/auth/login/email/',
  [NEWSLETTER_REGISTRATION]: () => '/newsletter/registration/',
  [NEWSLETTER_REGISTRATION_CONFIRM]: () => '/newsletter/registration/confirm/',
  [NEWSLETTER_UNREGISTER]: () => '/newsletter/unregister/',
  [NOT_FOUND]: () => '/not-found/',
  [PASSWORD_RESET_CHANGE]: () => '/auth/password/reset/',
  [PASSWORD_RESET_SENT]: () => '/auth/password/request-reset/confirm/',
  [PATIENCE]: () => '/auth/login/card/patience/',
  [PRE_LOGIN]: () => '/auth/login/overview/',
  [PRE_REGISTER]: () => '/auth/registration/overview/',
  [PRODUCT]: query => `/vetements-femmes/${query.slug}/id/${query.id}/`,
  [PRODUCT_AVAILABILITY]: query =>
    `/vetements-femmes/${query.slug}/id/${query.id}/#availability`,
  [PRODUCTS_CATEGORY]: query =>
    `/vetements-femmes/categorie/${query.slug}/id/${query.id}/`,
  [PRODUCTS_NEW]: () => '/vetements-femmes/nouvelles/',
  [PRODUCTS_OFFER]: () => '/vetements-femmes/offres/',
  [PRODUCTS_SALE]: () => '/vetements-femmes/sale/',
  [REGISTER]: () => '/auth/registration/',
  // TODO translate url
  [REGISTER_SUCCESS]: () => '/auth/registration/success/',
  [STORE]: query => `/magasins/${query.slug}/id/${query.store}/`,
  [STORE_FINDER]: query => `/magasins/${query.type || 'tous'}/`,
  [VERIFY_ADDRESS]: query => `/verify-address/${query.token}/`,
  [VIP_ACTIVITIES]: query => `/vip/activities/${query.type}/`,
  [VIP_ACTIVITIES_ALL]: () => '/vip/activities/all/',
  [VIP_ACTIVITIES_PURCHASES]: () => '/vip/activities/purchase/',
  [VIP_CARD_LOGIN]: () => '/auth/login/card/',
  [VIP_GOODIES]: () => '/vip/goodies/',
  [VIP_HOME]: () => '/vip/',
  [VIP_SETTINGS]: () => '/vip/settings/',
  [VIP_SETTINGS_ACCOUNT_DELETION]: () => '/vip/settings/account-deletion/',
  [VIP_SETTINGS_AVATAR]: () => '/vip/settings/avatar/',
  [VIP_SETTINGS_CHANGE_EMAIL]: () => '/vip/settings/change-email/',
  [VIP_SETTINGS_CHANGE_EMAIL_CONFIRM]: () =>
    '/vip/settings/change-email/confirm/',
  [VIP_SETTINGS_CHANGE_EMAIL_TOKEN]: () =>
    '/vip/settings/change-email-confirm/',
  [VIP_SETTINGS_CHANGE_PASSWORD]: () => '/vip/settings/change-password/',
  [VIP_SETTINGS_NOTIFICATIONS]: () => '/vip/settings/notifications/',
  [VIP_SETTINGS_PROFILE_DETAILS]: () => '/vip/settings/profile/',
  [VIP_SINGLE_PURCHASE]: query => `/vip/purchase/${query.id}/`,
  [VIP_VOUCHERS]: () => '/vip/vouchers/',
  [VIP_INVALID_CARD]: () => '/auth/login/card/unavailable-for-signup/',
  [VIP_CARD_NOT_YET_ACTIVATED]: () => '/auth/login/card/not-activated/',
  [VIP_CARD_INVALID_EMAIL]: () => '/auth/login/card/invalid-email/',
  [VIP_CARD_ALREADY_ACTIVATED]: () => '/auth/login/card/already-activated/',
  // TODO translate url
  [GAME_WOF]: () => '/wof-splash/',
  [GAME_WOF_PLAY]: query => `/wof-web?token=${query.token}`,
  [GAME_WOF_PLAYED]: () => '/wof-played/',
  [GAME_WOF_UNAVAILABLE]: () => '/wof-unavailable/',
  [GAME_BAG]: () => '/bag-challenge-splash/',
  [GAME_EASTER_JACKPOT]: () => '/easter-jackpot-splash/',
  [GAME_TROPHY_HUNT]: () => '/trophy-hunt-splash/',
  [GAME_ADVENTCALENDAR]: () => '/adventcalendar-splash/',
  [SHOP_EVENT]: () => '/moments-online-shopping-day/',
  [SHOP_EVENT_PRODUCT]: query =>
    `/moments-online-shopping-day/products/${query.slug}/${query.id}/`,
  [BASKET]: () => '/panier/',
  [CHECKOUT]: () => '/checkout/',
  [CHECKOUT_SUCCESS]: () => '/checkout/success/',
  [CHECKOUT_GATEWAY]: query => `/checkout/gateway/${query.paymentStatus}/`,
  [DELIVERY_CONDITIONS]: () =>
    '/moments-online-shopping-day-conditions-de-livraison/',
  [GIFT_CARDS_BALANCE_CHECK]: () =>
    `/carte-cadeau/${GIFT_CARDS_VIEW_MODE_FR.BALANCE}/resultat/`,
  [GIFT_CARDS_PURCHASE_SUMMARY]: () => '/carte-cadeau/checkout/',
  [GIFT_CARDS_PURCHASE_SUCCESS]: () => '/carte-cadeau/checkout/success/',
  [GIFT_CARDS_PURCHASE_GATEWAY]: query =>
    `/carte-cadeau/checkout/gateway/${query.paymentStatus}`,
  [GIFT_CARDS_VIEW]: query =>
    `/carte-cadeau/${query.view || GIFT_CARDS_VIEW_MODE_FR.PURCHASE}/`,
};

export const frenchUrlsLinkGenerationRouteMap = {
  [HOME]: '/',
  [ACCOUNT_OPTIMIZATION]: '/vip/account-optimization/',
  [ACTIVATE_ACCOUNT]: '/auth/activation/',
  [ACTIVATION_RESEND]: '/auth/activation/resend/',
  [AUTH_TERMS_AND_CONDITIONS]: '/auth/cgv/',
  [CREATE_PROFILE]: '/auth/customer/create/',
  [EMAIL_SENT]: '/auth/activation/email-sent-confirm/',
  [FAVORITES]: '/vip/favorites/',
  [FORGOT_PASSWORD]: '/auth/password/request-reset/',
  [GOODIES_DETAILS]: '/goodies/:slug/id/:id/',
  [JOBS_APPLICATION_SENT]: '/travailler-pour-chicoree/application-sent/',
  [JOBS_JOB_OFFER_DETAILS]: '/postes-vacants/:slug/id/:id/',
  [JOBS_OPERATION_AREA_DETAILS]: '/travailler-pour-chicoree/:slug/id/:id/',
  [JOBS_SPONTANEOUS_APPLICATION]:
    '/travailler-pour-chicoree/candidature-spontanee/',
  [LOGIN]: '/auth/login/email/',
  [NEWSLETTER_REGISTRATION]: '/newsletter/registration/',
  [NEWSLETTER_REGISTRATION_CONFIRM]: '/newsletter/registration/confirm/',
  [NEWSLETTER_UNREGISTER]: '/newsletter/unregister/',
  [NOT_FOUND]: '/not-found/',
  [PASSWORD_RESET_CHANGE]: '/auth/password/reset/',
  [PASSWORD_RESET_SENT]: '/auth/password/request-reset/confirm/',
  [PATIENCE]: '/auth/login/card/patience/',
  [PRE_LOGIN]: '/auth/login/overview/',
  [PRE_REGISTER]: '/auth/registration/overview/',
  [PRODUCT]: '/vetements-femmes/:slug/id/:id/',
  [PRODUCT_AVAILABILITY]: '/vetements-femmes/:slug/id/:id/#availability/',
  [PRODUCTS_CATEGORY]: '/vetements-femmes/categorie/:slug/id/:id/',
  [PRODUCTS_NEW]: '/vetements-femmes/nouvelles/',
  [PRODUCTS_OFFER]: '/vetements-femmes/offres/',
  [PRODUCTS_SALE]: '/vetements-femmes/sale/',
  [PRODUCTS_ALL]: '/vetements-femmes/',
  [PRODUCTS_CATCH_ALL]: '/vetements-femmes/:slug+',
  [REGISTER]: '/auth/registration/',
  [REGISTER_SUCCESS]: '/auth/registration/success/',
  [STORE]: '/magasins/:slug/id/:store/',
  [STORE_FINDER]: '/magasins/:type/',
  [VERIFY_ADDRESS]: '/verify-address/:token/',
  [VIP_ACTIVITIES]: '/vip/activities/:type/',
  [VIP_CARD_LOGIN]: '/auth/login/card/',
  // [VIP_GOODIES]: '/vip/goodies/',
  [VIP_HOME]: '/vip/',
  [VIP_SETTINGS]: '/vip/settings/',
  [VIP_SETTINGS_ACCOUNT_DELETION]: '/vip/settings/account-deletion/',
  [VIP_SETTINGS_AVATAR]: '/vip/settings/avatar/',
  [VIP_SETTINGS_CHANGE_EMAIL]: '/vip/settings/change-email/',
  [VIP_SETTINGS_CHANGE_EMAIL_CONFIRM]: '/vip/settings/change-email/confirm/',
  [VIP_SETTINGS_CHANGE_EMAIL_TOKEN]: '/vip/settings/change-email-confirm/',
  [VIP_SETTINGS_CHANGE_PASSWORD]: '/vip/settings/change-password/',
  [VIP_SETTINGS_NOTIFICATIONS]: '/vip/settings/notifications/',
  [VIP_SETTINGS_PROFILE_DETAILS]: '/vip/settings/profile/',
  [VIP_SINGLE_PURCHASE]: '/vip/purchase/:id/',
  // [VIP_VOUCHERS]: '/vip/vouchers/',
  [VIP_INVALID_CARD]: '/auth/login/card/unavailable-for-signup/',
  [VIP_CARD_NOT_YET_ACTIVATED]: '/auth/login/card/not-activated/',
  [VIP_CARD_INVALID_EMAIL]: '/auth/login/card/invalid-email/',
  [VIP_CARD_ALREADY_ACTIVATED]: '/auth/login/card/already-activated/',
  [GAME_WOF]: '/wof-splash/',
  [GAME_WOF_PLAY]: '/wof-web/',
  [GAME_WOF_PLAYED]: '/wof-played/',
  [GAME_WOF_UNAVAILABLE]: '/wof-unavailable/',
  [GAME_BAG]: '/bag-challenge-splash/',
  [GAME_EASTER_JACKPOT]: '/easter-jackpot-splash/',
  [GAME_TROPHY_HUNT]: '/trophy-hunt-splash/',
  [GAME_ADVENTCALENDAR]: '/adventcalendar-splash/',
  [CMS_LOOKBOOK_PAGE]: '/lookbooks/:slug/',
  [SHOP_EVENT]: '/moments-online-shopping-day/',
  [SHOP_EVENT_PRODUCT]: '/moments-online-shopping-day/products/:slug/:id/',
  [BASKET]: '/panier/',
  [CHECKOUT]: '/checkout/',
  [CHECKOUT_SUCCESS]: '/checkout/success/',
  [CHECKOUT_GATEWAY]: '/checkout/gateway/:paymentStatus/',
  [DELIVERY_CONDITIONS]:
    '/moments-online-shopping-day-conditions-de-livraison/',
  [GIFT_CARDS_BALANCE_CHECK]: `/carte-cadeau/${GIFT_CARDS_VIEW_MODE_FR.BALANCE}/resultat/`,
  [GIFT_CARDS_PURCHASE_SUMMARY]: '/carte-cadeau/checkout/',
  [GIFT_CARDS_PURCHASE_SUCCESS]: '/carte-cadeau/checkout/success/',
  [GIFT_CARDS_PURCHASE_GATEWAY]:
    '/carte-cadeau/checkout/gateway/:paymentStatus/',
  [GIFT_CARDS_VIEW]: '/carte-cadeau/:view/',

  // NOTE: overwrite the goodies and vouchers routes as they are temporarily not available
  '/vip/goodies-vouchers-splash': {
    source: '/vip/:goodiesVouchers(goodies|vouchers)/',
    pattern: '/vip/(goodies|vouchers)-splash/',
  },

  [CMS_PAGE]: {
    source: '/:slug((?!_next))+/',
    pattern: '/*',
  },
};

const LANGUAGE_ROUTES = [
  ['de', germanUrlsLinkGenerationRouteMap],
  ['fr', frenchUrlsLinkGenerationRouteMap],
];

export default { LANGUAGE_ROUTES, NOT_CACHEABLE_ROUTES };
